const STAGE = [];

export default STAGE;
